import {anyImageOpResult} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {z} from "zod/v4-mini"
import {sourceType} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/image-op-per-pixel-fn/definition"
import {imageOpHalOptions} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/hal/image-op-hal-types"

export const unaryOperator = z.union([
    z.literal("length"),
    z.literal("sqrt"),
    z.literal("square"),
    z.literal("cos"),
    z.literal("sin"),
    z.literal("clip01"),
    z.literal("abs"),
    z.literal("isNaN"),
])

export const unary = z.object({
    imageOpHalOptions: imageOpHalOptions,

    operator: unaryOperator,
    operand: sourceType,
})

export const binaryOperator = z.union([
    z.literal("+"),
    z.literal("-"),
    z.literal("*"),
    z.literal("/"),
    z.literal("/safe"),
    z.literal(">"),
    z.literal("<"),
    z.literal(">="),
    z.literal("<="),
    z.literal("=="),
    z.literal("max"),
    z.literal("min"),
    z.literal("atan2"),
    z.literal("pow"),
    z.literal("mod"),
    z.literal("distance"),
])

export const binary = z.object({
    imageOpHalOptions: imageOpHalOptions,

    operator: binaryOperator,
    operandA: sourceType,
    operandB: sourceType,
})

export const definition = {
    validation: {
        returns: anyImageOpResult,
        parameters: z.union([unary, binary]),
    },
}
